/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var receipt = "";
  $on('pageInit', function () {
    for (var i = 0; i < 20; i++) {
      var data = localStorage.getItem("history" + i);
      console.log(data);

      if (data != "" && data != undefined && data != "null") {
        var arr = data.split(":");
        receipt += "\n            <tr>\n              <td class=\"label-cell\">" + arr[2] + arr[3] + "</td>\n              <td class=\"label-cell\"><button class=\"button button-fill button-view\" id=\"" + i + "\">Rebuy</button></td>\n            </tr>\n        ";
        $update();
      }

      $(document).on("click", ".button-view", function (e) {
        var codeEnter = localStorage.getItem("history" + e.srcElement.id);

        if (codeEnter.includes("QR")) {
          window.origin = "rebuy";

          var _arr = codeEnter.split(":");

          var data = "\n          {\n            \"orderEntry\":\"" + _arr[4] + "\",\n            \"smsnum\":\"" + _arr[2] + "-" + _arr[3] + "\",\n            \"form\":\"" + _arr[1] + "\"\n          }\n          ";
          console.log(data);
          window.data = JSON.parse(data);
          if (window.data.form == "1") $f7.views.main.router.navigate("/kiosk_4d_GD_only/");
          if (window.data.form == "2") $f7.views.main.router.navigate("/kiosk_4d_GD/");
          if (window.data.form == "3") $f7.views.main.router.navigate("/kiosk_6d_GD/");
          if (window.data.form == "4") $f7.views.main.router.navigate("/kiosk_4d_SG_only/");
          if (window.data.form == "5") $f7.views.main.router.navigate("/kiosk_4d_SG/");
          if (window.data.form == "6") $f7.views.main.router.navigate("/kiosk_4d_ST/");
          if (window.data.form == "7") $f7.views.main.router.navigate("/kiosk_6d_ST/");
          if (window.data.form == "8") $f7.views.main.router.navigate("/kiosk_pick_GD/");
          if (window.data.form == "9") $f7.views.main.router.navigate("/kiosk_pick_SG/");
          if (window.data.form == "9") $f7.views.main.router.navigate("/kiosk_pick_SG/");
          if (window.data.form == "11") $f7.views.main.router.navigate("/kiosk_pick_SG_S/");
          $f7.tab.show("#view-home", true);
          return;
        }
      });
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">GD Lotaria</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">
      <span class='en'>History</span>
      <span class='cn'>历史</span>
      <span class='tl'>istória</span>
    </div>
    <div class="block">
      
        <span class='en'>Previous order for repurchase</span>
        <span class='cn'>之前的回购订单</span>
        <span class='tl'>Orden uluk atu sosa fali</span>
      
    </div>






    <div class="block-title">
      <span class='en'>Search Result</span>
      <span class='cn'>搜索结果</span>
      <span class='tl'>Buka rezultado</span>
    </div>
    <div class="card data-table">
      <table>
        <thead>
          <tr>
            <th class="label-cell">
              <span class='en'>User Phone</span>
              <span class='cn'>用户电话</span>
              <span class='tl'>Telemovel</span>
            </th>
            <th class="numeric-cell">
              <span class='en'>Action</span>
              <span class='cn'>行动</span>
              <span class='tl'>Asaun</span>
            </th>
          </tr>
        </thead>
        <tbody innerHTML=${receipt}>

        </tbody>
      </table>
    </div>

  </div>
</div>
`
    }
    ;
}

framework7Component.id = '7706dc96d7';
export default framework7Component;